<template>
  <div :class="['ls-required-service-item', { danger: getInfo.isLGQ }]">
    <div>
      <LsServiceEventItemHeader
        :service-name="getRequiredServiceText"
        :color="getInfo.color"
        is-quote
      />
      <LsServiceEventItem
        :icon="getInfo.icon"
        :status-text="getInfo.statusText"
        :start-date="getInfo.startDate"
        :end-date="getInfo.endDate"
        is-quote
      />
    </div>
    <LsButton
      class="ls-required-service-item--button"
      text="review & approve"
      :bg-color="getInfo.color"
      text-color="white"
      track-id="ls_required_service_item-review_and_approve"
      test-id="review_and_approve"
      @click="$emit('click')"
    />
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import LsServiceEventItem from '../LsServiceEventItem/LsServiceEventItem.vue';
import { lsRequiredServiceItemHelpers } from '@/helpers';
import { lsFilters, lsPropTypeHelpers } from 'ls-vue-common';
import LsServiceEventItemHeader from '@/components/ServiceItems/LsServiceEventItemHeader/LsServiceEventItemHeader.vue';
import { LsButton } from '@/components/common';

export default {
  name: 'LsRequiredServiceItem',
  components: {
    LsButton,
    LsServiceEventItem,
    LsServiceEventItemHeader,
  },
  props: {
    requiredService: VueTypes.shape({
      blockedSchedules: VueTypes.arrayOf(
        VueTypes.shape({
          schedule_id: VueTypes.number,
          service: VueTypes.shape({
            name: VueTypes.string,
          }).loose,
          status: VueTypes.oneOf(['active', 'ended', 'cancelled', 'paused']),
          type: VueTypes.oneOf(['service', 'paw', 'manualquote', 'qualityassurance']),
        }).loose
      ).loose,
      expires_at: VueTypes.custom(lsPropTypeHelpers.stringOrNull), // YYYY-MM-DD HH:mm:ss
      requiredService_id: VueTypes.number,
      service: VueTypes.shape({
        name: VueTypes.string,
      }).loose,
      type: VueTypes.string,
      schedule_at: VueTypes.custom(lsPropTypeHelpers.stringOrNull), // YYYY-MM-DD HH:mm:ss
      status: VueTypes.oneOf(['new', 'ready', 'approved', 'rejected', 'expired', 'cancelled']),
      status_set_at: VueTypes.custom(lsPropTypeHelpers.stringOrNull), // YYYY-MM-DD HH:mm:ss
      updated_at: VueTypes.custom(lsPropTypeHelpers.stringOrNull), // YYYY-MM-DD HH:mm:ss
    }).isRequired.loose,
    trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
  },

  computed: {
    getRequiredServiceText() {
      return `Required ${lsFilters.titleCase({ text: this.requiredService.service.name })}`;
    },
    getInfo() {
      return lsRequiredServiceItemHelpers.getRequiredServiceItemDisplayValues({
        requiredService: this.requiredService,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-required-service-item {
  padding: 20px;
  margin: 20px 0;
  background: $primary-light;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.ls-required-service-item--button {
  margin-left: auto;
  @media (max-width: $mobile-max-width) {
    margin-top: 20px;
  }
}

.themed-app {
  .ls-required-service-item {
    background: $theme-color-primary-light;

    &.danger {
      background-color: $theme-color-danger-light;
    }
  }
}
</style>
